//
import ProviderModel from "@/models/Purchase/PchProvider"
import OrdererPriorityModel from "@/models/Warehouse/WhOrdererPriority"
import UserModel from "@/models/General/GUser"
import WarehouseModel from "@/models/Warehouse/WhWarehouse"

//
export default [
    {
        name    : "wh_orderer.pch_provider_id",
        type    : "autocomplete-model",
        props   : {
            itemText    : "rut",
            itemValue   : "id",
            label       : "Rut",
            model       : ProviderModel,
            noObject    : true,
            paramSearch : "search",
        },
    },
    {
        name    : "wh_orderer.pch_provider_id",
        type    : "autocomplete-model",
        props   : {
            itemText    : "alias_name",
            itemValue   : "id",
            label       : "Proveedor",
            model       : ProviderModel,
            noObject    : true,
            paramSearch : "search",
        },
    },
    {
        name    : "wh_orderer.wh_orderer_priority_id",
        type    : "autocomplete-model",
        props   : {
            itemText    : "priority",
            itemValue   : "id",
            label       : "Prioridad",
            model       : OrdererPriorityModel,
            noAsyncSearch: true,
            noObject    : true,
            paramSearch : "search",
        },
    },
    {
        name    : "wh_orderer.g_supervisor_user_id",
        type    : "autocomplete-model",
        props   : {
            itemText    : "full_name",
            itemValue   : "id",
            label       : "Responsable",
            model       : UserModel,
            noObject    : true,
            paramSearch : "search",
        },
    },
    {
        name    : "wh_orderer.wh_warehouse_id",
        type    : "autocomplete-model",
        props   : {
            itemText    : "name",
            itemValue   : "id",
            label       : "Bodega",
            model       : WarehouseModel,
            noObject    : true,
            paramSearch : "search",
        },
    },
    {
        name    : "was_processed",
        type    : "select",
        props   : {
            items   : [
                { 
                    text    : "Procesada", 
                    value   : 1 
                },
                { 
                    text    : "Sin procesada", 
                    value   : 0 
                },
            ],
            label   : "Estado",
        },
    },  
]